import React from "react";
import PropTypes from "prop-types";
import _, { get } from "lodash";
import {
  change,
  Field,
  FieldArray,
  Fields,
  formValueSelector,
  getFormInitialValues,
  getFormValues
} from "redux-form";
import { connect } from "react-redux";
import { Col, FormGroup, Row } from "react-bootstrap";
import api from "APP_ROOT/api";
import {
  form,
  Form as AppForm,
  Select,
  AutoCompleteField,
  AutoCompleteUserInputField,
  FormInput,
  MonthYearField,
  TextArea,
  CheckGroup,
  Check
} from "MODULES/shared/components/Forms";
import { toOptions } from "LIB/forms";
import * as partsActions from "MODULES/parts/actions/actions";
import { create, save } from "MODULES/Receiving/actions";
import AttachmentListSection from "MODULES/Receiving/components/shared/FormSections/AttachmentListSection";
import { Warning } from "MODULES/shared/components";
import NetWeightAndDimsFormRow from "MODULES/shared/components/Forms/NetWeightAndDimsFormRow/NetWeightAndDimsFormRow";
import { RO_ITEM, SO_ITEM, PO_ITEM } from "MODULES/Orders/shared/constants";
import {
  ACTIVE,
  COMPANY,
  CREDIT_HOLD,
  IMPERFECT_TRACE,
  IMPERFECT_TRACE_REASON,
  INTERNAL_NOTE
} from "MODULES/companies/constants";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { properCase } from "LIB/formatters/text";
import {
  CAAC,
  CONDITION,
  EASA,
  EXPIRATION,
  FAA,
  IMPERFECT_TRACE_REASONS,
  LOCATION,
  NEW_ITEM,
  OTHER,
  OTHER_TAG_TYPE,
  PART_ID,
  SERIAL_NUMBER,
  STORE_LOCATION,
  STORE_LOCATION_ID,
  TAG_DATE,
  TAGGED_BY,
  TCCA,
  TRACE_TYPE,
  TRACED_TO,
  UK_CAA
} from "MODULES/inventories/constants";
import { ATTACHMENTS, AWB_NUMBER, QUANTITY, TYPE } from "APP_ROOT/constants";
import {
  BIO_HAZMAT,
  CAGE,
  DOM,
  ESD,
  HAZMAT,
  PART,
  SHELF_LIFE
} from "MODULES/parts/constants";
import * as poActions from "MODULES/PurchaseOrders/actions";
import BuyerField from "MODULES/PurchaseOrders/shared/CoBuyersFields/BuyerField";
import {
  ATTACHMENT_TYPES,
  CONDITION_TYPES,
  CONSIGNMENT,
  CONSIGNMENT_REFERENCE,
  CONSIGNMENT_REFERENCE_COMPANY_ID,
  CONSIGNOR_PERCENTAGE,
  MISTAKE_SHIPMENT,
  RECEIVING_CHECKLIST_QUESTIONS,
  RECEIVING_TYPE,
  SETTABLE_RECEIVING_TYPES,
  TRANSFER,
  CONSIGNMENT_BUYER_ID,
  EMA,
  OVERHAULED,
  REPAIRED,
  INSPECTED,
  CONSIGNMENT_CO_BUYER_ID,
  PO,
  AS_REMOVED,
  SCRAP,
  BEYOND_ECON_REPAIR,
  PARTS_UNIT,
  CONSIGNMENT_LINE_ITEM
} from "MODULES/Receiving/constants";
import Catalog from "MODULES/parts/components/Detail/Catalog";
import { fromJS } from "immutable";
import { NSN_ABBREV } from "MODULES/Receiving/Dashboard/Create/Create";
import {
  MOD_TO,
  REPAIR_EVALUATION_APPROVED
} from "MODULES/RepairOrders/constants";
import ReduxFormLocationDropdown from "MODULES/Locations/components/ReduxFormLocationsDropdown";
import { EXPECTED_SERIAL_NUMBER } from "MODULES/PurchaseOrders/constants";
import { isModTo } from "MODULES/Receiving/helpers";
import LotSection from "MODULES/Receiving/Dashboard/Create/FormSections/LotSection";
import {
  requireTagDate,
  requireTaggedBy
} from "MODULES/Receiving/Dashboard/Create/helpers";
import FormFooter from "MODULES/Receiving/Dashboard/Create/FormFooter";
import { INCOMING_LINE_ITEMS } from "MODULES/IncomingQuotes/constants";
import TagTypes from "MODULES/inventories/components/EditInventory/TagTypes";
import { USER } from "MODULES/users/constants";
import DupeWarning from "MODULES/Receiving/Dashboard/Create/Warnings/DupeWarning";
import MistakeShipmentSection from "./FormSections/MistakeShipmentSection";
import validate from "./validate";

const formName = "createReceivingRecord";

function EmaWarning({ receivingType }) {
  if (receivingType !== EMA) return null;

  return (
    <Warning>
      NOTE: Upon Sale of item, PO will be automatically created at which point,
      once negotiated with Vendor, you will be able to adjust the Purchase Price
      and send the PO.
    </Warning>
  );
}

EmaWarning.propTypes = {
  receivingType: PropTypes.string
};

function Quantity({ serial_number, setFieldValue, quantity, receivingType }) {
  const handleChange = e => {
    const val = e.target.value;
    if (val < 0) {
      quantity.input.onChange(0);
      setFieldValue(QUANTITY)(0);
    } else {
      quantity.input.onChange(val);
    }

    if (receivingType === TRANSFER) {
      // Serial number should not be editable for transfers
      return;
    }

    if (val > 1) {
      serial_number.input.onChange(NSN_ABBREV);
    } else {
      serial_number.input.onChange("");
    }
  };

  return (
    <Field
      type="number"
      name={QUANTITY}
      component={FormInput}
      label="Qty Received"
      className="form-control"
      onChange={handleChange}
      normalize={value => (value && value < 0 ? 0 : value)}
      parse={value => value && parseInt(value, 10)}
      required
    />
  );
}
Quantity.propTypes = {
  serial_number: PropTypes.instanceOf(Object).isRequired,
  quantity: PropTypes.instanceOf(Object).isRequired,
  receivingType: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func
};

const getWarningMessages = part => {
  const warnings = [];
  if (get(part, ESD)) warnings.push("ESD");
  if (get(part, SHELF_LIFE)) warnings.push("shelf life");
  if (get(part, HAZMAT)) warnings.push("hazmat");
  if (get(part, BIO_HAZMAT)) warnings.push("bio-hazmat");

  return warnings;
};

export class Form extends React.Component {
  state = {
    selectedCompany: null,
    selectedLot: null,
    selectedPart: null,
    selectedConsignor: null,
    selectedConsignmentBuyer: null,
    nextConsignment: null
  };

  componentWillMount() {
    const { receivingRecord } = this.props;
    this.setState({ forceClear: 0 });
    if (receivingRecord) {
      if (
        receivingRecord.type === RO_ITEM &&
        receivingRecord.approval_status === REPAIR_EVALUATION_APPROVED
      ) {
        [FAA, EASA, CAAC, TCCA, OTHER].forEach(f =>
          this.props.change(f, receivingRecord.company[`${f}_approved`])
        );
      }
      if (receivingRecord.type === PO_ITEM) {
        if (receivingRecord.line_item[OTHER_TAG_TYPE]) {
          this.props.setFieldValue(OTHER)(true);
        }
        [FAA, EASA, CAAC, TCCA, OTHER, OTHER_TAG_TYPE].forEach(f =>
          this.props.change(f, receivingRecord.line_item[`${f}`])
        );
      }
      let selectedCompany;
      if (
        RO_ITEM === receivingRecord.type &&
        receivingRecord.approval_status === REPAIR_EVALUATION_APPROVED
      ) {
        selectedCompany = get(receivingRecord, COMPANY);
      } else if (SO_ITEM === receivingRecord.type) {
        selectedCompany = undefined;
      } else if (RO_ITEM !== receivingRecord.type) {
        selectedCompany = receivingRecord;
      }

      this.setState({
        selectedPart: isModTo(receivingRecord)
          ? get(receivingRecord, MOD_TO)
          : receivingRecord,
        selectedCompany
      });
    }
  }

  searchCompanies = filter =>
    api.companies
      .search({
        filter,
        status: [ACTIVE, CREDIT_HOLD].join(","),
        page: 1,
        limit: 20
      })
      .then(resp => resp.data.results);

  searchConsignment = filter =>
    api.consignments
      .search({
        filter
      })
      .then(resp => {
        const lastConsignment = _.get(resp, "data.data.last_consignment");
        if (lastConsignment && !isNaN(Number(lastConsignment))) {
          return [String(Number(lastConsignment) + 1)].concat(
            resp.data.results
          );
        }

        return resp.data.results;
      });

  formatConsignment = result => {
    if (typeof result === "object" && result !== null) {
      return result.consignment_reference;
    }

    if (typeof result === "string") {
      return result;
    }

    return null;
  };

  selectConsignment = result => {
    if (typeof result === "object" && result !== null) {
      this.props.setFieldValue(CONSIGNMENT_BUYER_ID)(result.buyer_id);
      this.props.setFieldValue(CONSIGNMENT_CO_BUYER_ID)(result.co_buyer_id);
      this.props.setFieldValue(CONSIGNOR_PERCENTAGE)(
        result.consignor_percentage
      );
      this.props.setFieldValue(CONSIGNMENT_REFERENCE_COMPANY_ID)(
        result.company_id
      );

      this.setState({
        selectedConsignor: result.company,
        selectedConsignmentBuyer: result.buyer,
        selectedConsignmentCoBuyer: result.co_buyer
      });

      return result.consignment_reference;
    }

    return result;
  };

  handleLotSelected = selectedLot => this.setState({ selectedLot });

  handlePartSelected = part => {
    this.setState({ selectedPart: part }, () => {
      this.props.setFieldValue(CAGE)(part.cage);
    });
  };

  handleTaggedBy = item => {
    if (item && item.id) {
      this.props.change("tagged_by_existing_company", true);
    }
    if (!item) {
      this.props.change("tagged_by_existing_company", false);
    }
  };

  receiveAnother = receivingType => {
    const {
      selectedConsignmentCoBuyer,
      selectedConsignmentBuyer,
      selectedConsignor,
      selectedLot,
      selectedPart,
      forceClear
    } = this.state;
    this.setState({
      selectedCompany: null,
      selectedPart: receivingType === PO ? selectedPart : null,
      selectedConsignmentCoBuyer,
      selectedConsignmentBuyer,
      selectedConsignor,
      selectedLot,
      forceClear: Number(forceClear) + 1
    });
  };

  renderChecklistQuestion = attr => (
    <Row className="row-col-gutters-half" key={attr}>
      <Col md={1} className="text-center">
        <label className="control-label" htmlFor={attr}>
          Agree
        </label>
        <br />
        <input
          type="radio"
          name={attr}
          className="radio-inline"
          checked={this.props.getField(attr)}
          onChange={() => this.props.change(attr, true)}
        />
      </Col>
      <Col md={1} className="text-center">
        <label className="control-label" htmlFor={attr}>
          Disagree
        </label>
        <br />
        <input
          type="radio"
          name={attr}
          className="radio-inline"
          checked={!this.props.getField(attr)}
          onChange={() => this.props.change(attr, false)}
        />
      </Col>
      <Col md={10}>{RECEIVING_CHECKLIST_QUESTIONS[attr]}</Col>
      <br />
      <br />
      <br />
    </Row>
  );

  render() {
    const {
      currentUser,
      allValues,
      getInitialFieldValue,
      getField,
      handleSubmit,
      submitFailed,
      searchParts,
      close,
      submitting,
      condition,
      quantity,
      receivingRecord,
      receivingType,
      setFieldValue,
      lockFields,
      errorMessages,
      virtualReceiving
    } = this.props;
    const {
      selectedPart,
      selectedCompany,
      selectedConsignor,
      selectedConsignmentBuyer,
      selectedConsignmentCoBuyer,
      selectedLot
    } = this.state;

    const warningMessages = getWarningMessages(selectedPart);

    const disableReleaseType = event => {
      if (
        [SCRAP, BEYOND_ECON_REPAIR, PARTS_UNIT, AS_REMOVED].includes(
          event.target.value
        )
      ) {
        [FAA, EASA, CAAC, TCCA, OTHER, OTHER_TAG_TYPE].map(f =>
          this.props.setFieldValue(f)(null)
        );
      }
    };

    return (
      <AppForm {...this.props}>
        <AppForm.Body>
          {warningMessages.length > 0 && (
            <Warning>
              Warning! PN is labeled as {warningMessages.join(", ")}.
            </Warning>
          )}
          <FormRow>
            {!receivingRecord && (
              <Col md={3}>
                <Field
                  name={RECEIVING_TYPE}
                  component={Select}
                  options={toOptions(SETTABLE_RECEIVING_TYPES)}
                  label={properCase(RECEIVING_TYPE)}
                  onChange={(_ev, type) => {
                    setFieldValue(RECEIVING_TYPE, type);
                    if (type === EMA) {
                      setFieldValue(LOCATION)(null);
                      setFieldValue(CONSIGNOR_PERCENTAGE)("0");
                    }
                  }}
                  required
                />
              </Col>
            )}
            <Col md={3}>
              <Field
                name={PART_ID}
                label="Part #"
                placeholder="Type a part's name of ID number..."
                component={AutoCompleteField}
                search={searchParts}
                disabled={lockFields}
                formatItem={result => result && result.part_number}
                selectedItem={selectedPart}
                onItemSelected={i => i && this.handlePartSelected(i)}
                required
              />
            </Col>
            <Col md={3}>
              <Field
                name={SERIAL_NUMBER}
                component={FormInput}
                label={properCase(SERIAL_NUMBER)}
                disabled={parseInt(quantity, 10) > 1 || lockFields}
                required={parseInt(quantity, 10) === 1}
              />
            </Col>
            <Col md={3}>
              <Field
                name={EXPECTED_SERIAL_NUMBER}
                component={FormInput}
                disabled
                label="Exp Serial #"
              />
            </Col>
            <Col md={3}>
              <Field
                name={CAGE}
                label={properCase(CAGE)}
                component={FormInput}
                disabled={this.props.initialValues[CAGE]}
              />
            </Col>
          </FormRow>
          {!receivingRecord && (
            <LotSection
              receivingType={receivingType}
              setFieldValue={setFieldValue}
              selectedLot={selectedLot}
              handleLotSelected={this.handleLotSelected}
            />
          )}

          <DupeWarning receivingRecord={receivingRecord} />
          <FormRow>
            <Col md={3}>
              <Field
                name={CONDITION}
                component={Select}
                options={toOptions(CONDITION_TYPES)}
                label="Condition Received"
                disabled={lockFields}
                onChange={e => disableReleaseType(e)}
                required
              />
            </Col>
            <Col md={2}>
              <Fields
                names={[SERIAL_NUMBER, QUANTITY]}
                component={Quantity}
                setFieldValue={setFieldValue}
                receivingType={receivingRecord && receivingRecord.type}
                lockFields={lockFields}
              />
            </Col>
            <Col md={4}>
              <MonthYearField
                name={DOM}
                component={FormInput}
                label="DOM"
                required={receivingRecord && receivingRecord.part.dom_sensitive}
              />
            </Col>
            <Col md={3}>
              <Field
                name={EXPIRATION}
                type="date"
                component={FormInput}
                label="exp"
                required={
                  get(receivingRecord, [PART, SHELF_LIFE].join(".")) &&
                  [OVERHAULED, REPAIRED, INSPECTED, NEW_ITEM].includes(
                    condition
                  )
                }
              />
            </Col>
          </FormRow>
          <FormRow>
            <Col md={2}>
              <MonthYearField
                name={TAG_DATE}
                component={FormInput}
                label={properCase(TAG_DATE)}
                required={requireTagDate(condition, receivingType)}
              />
            </Col>
            <Col md={2}>
              <Field
                name={TAGGED_BY}
                label={properCase(TAGGED_BY)}
                placeholder="Search by a company's name"
                component={AutoCompleteUserInputField}
                search={this.searchCompanies}
                selectedItem={selectedCompany}
                formatItem={result =>
                  (result && result.name) || result.tagged_by}
                handleTaggedBy={this.handleTaggedBy}
                required={requireTaggedBy(condition, receivingType)}
                forceClear={this.state.forceClear}
              />
            </Col>
            <Col md={2}>
              <div className="form-group">
                <Field
                  name={TRACE_TYPE}
                  component={Select}
                  options={toOptions(INCOMING_LINE_ITEMS.traceTypes)}
                  label={properCase(TRACE_TYPE)}
                />
              </div>
            </Col>
            <Col md={2}>
              <div className="form-group">
                <Field
                  name={TRACED_TO}
                  component={FormInput}
                  label={properCase(TRACED_TO)}
                />
              </div>
            </Col>
            <Col md={2}>
              <ReduxFormLocationDropdown
                disabled
                name={STORE_LOCATION_ID}
                label={properCase(STORE_LOCATION)}
                required
              />
            </Col>
            <Col md={2}>
              <Field
                name={LOCATION}
                component={FormInput}
                label={properCase(LOCATION)}
                required={receivingType !== EMA}
                disabled={receivingType === EMA || virtualReceiving}
              />
            </Col>
          </FormRow>
          {_.get(currentUser, "tenant.ware_houses", []).length > 0 && (
            <FormRow>
              <Col md={2}>
                <Field
                  name="ware_house_id"
                  component={Select}
                  options={currentUser.tenant.ware_houses.map(wareHouse => ({
                    value: wareHouse.id,
                    text: wareHouse.name
                  }))}
                  label={properCase("warehouse")}
                />
              </Col>
            </FormRow>
          )}
          <FormRow>
            <Col md={12}>
              <Fields
                names={[FAA, EASA, UK_CAA, CAAC, TCCA, OTHER, OTHER_TAG_TYPE]}
                component={TagTypes}
                formName={formName}
                disabled={
                  receivingRecord &&
                  [SCRAP, BEYOND_ECON_REPAIR, PARTS_UNIT, AS_REMOVED].includes(
                    getField(CONDITION)
                  )
                }
              />
            </Col>
          </FormRow>
          <FormRow>
            <Col md={getField(IMPERFECT_TRACE) ? 9 : 12}>
              <CheckGroup justified title="Flags">
                <Field
                  name={IMPERFECT_TRACE}
                  component={Check}
                  label={properCase(IMPERFECT_TRACE)}
                />
                <Field name="der" component={Check} label="DER" />
                <Field name="pma" component={Check} label="PMA" />
                <Field name="modified" component={Check} label="Modified" />
                <Field name="incident" component={Check} label="Incident" />
              </CheckGroup>
            </Col>
            {getField(IMPERFECT_TRACE) && (
              <Col md={3}>
                <Field
                  name={IMPERFECT_TRACE_REASON}
                  component={Select}
                  options={toOptions(IMPERFECT_TRACE_REASONS)}
                  label="Imperfect Trace Reason"
                />
              </Col>
            )}
          </FormRow>
          <FormRow>
            <Col md={6}>
              <Field name={AWB_NUMBER} component={FormInput} label="Awb #" />
            </Col>
            <Col md={2}>
              <Field
                allowUserInput
                name={CONSIGNMENT_REFERENCE}
                component={AutoCompleteUserInputField}
                label="Consignment / EMA Ref #"
                selectedItem={get(receivingRecord, CONSIGNMENT_REFERENCE)}
                search={this.searchConsignment}
                formatItem={this.formatConsignment}
                required={
                  receivingType === CONSIGNMENT && !get(receivingRecord, TYPE)
                }
                disabled={
                  ![CONSIGNMENT, EMA].includes(receivingType) ||
                  get(receivingRecord, TYPE) === CONSIGNMENT_LINE_ITEM
                }
                input={{
                  onChange: val => {
                    setFieldValue(CONSIGNMENT_REFERENCE)(
                      val && val.consignment_reference
                    );

                    this.selectConsignment(val);
                  },
                  onBlur: val =>
                    setFieldValue(CONSIGNMENT_REFERENCE)(
                      val && val.consignment_reference
                    )
                }}
              />
            </Col>
            {[CONSIGNMENT, EMA].includes(receivingType) &&
              !get(receivingRecord, TYPE) && (
                <Col md={3}>
                  <Field
                    name={CONSIGNMENT_REFERENCE_COMPANY_ID}
                    label="Consignment / EMA Ref Co."
                    placeholder="Search by a company's name"
                    component={AutoCompleteField}
                    disabled={receivingType === CONSIGNMENT}
                    onItemSelected={item =>
                      this.setState({ selectedConsignor: item })}
                    search={this.searchCompanies}
                    selectedItem={selectedConsignor}
                    formatItem={result => result && result.name}
                    required
                  />
                </Col>
              )}
            {get(receivingRecord, "part.catalog_url") && (
              <Col md={4}>
                <Catalog part={fromJS(receivingRecord.part)} />
              </Col>
            )}
          </FormRow>
          <FormRow>
            {[CONSIGNMENT, EMA].includes(receivingType) &&
              !get(receivingRecord, TYPE) && [
                <Col md={2}>
                  <FormGroup>
                    <Field
                      label="Consignor / EMA %"
                      name={CONSIGNOR_PERCENTAGE}
                      component={FormInput}
                      type="number"
                      inputProps={{
                        min: 0,
                        max: 100
                      }}
                      required
                      disabled={receivingType === CONSIGNMENT}
                    />
                  </FormGroup>
                </Col>,
                <Col md={3}>
                  <FormGroup>
                    <BuyerField
                      label="Cons / EMA Buyer Credit"
                      name={CONSIGNMENT_BUYER_ID}
                      searchBuyers={this.props.searchBuyers}
                      selectedBuyer={selectedConsignmentBuyer}
                      onItemSelected={item =>
                        this.setState({ selectedConsignmentBuyer: item })}
                      disabled={receivingType === CONSIGNMENT}
                    />
                  </FormGroup>
                </Col>,
                <Col md={3}>
                  <FormGroup>
                    <BuyerField
                      label="Cons / EMA Co Buyer Credit"
                      name={CONSIGNMENT_CO_BUYER_ID}
                      required={false}
                      searchBuyers={this.props.searchBuyers}
                      selectedBuyer={selectedConsignmentCoBuyer}
                      onItemSelected={item =>
                        this.setState({ selectedConsignmentCoBuyer: item })}
                      disabled={receivingType === CONSIGNMENT}
                    />
                  </FormGroup>
                </Col>
              ]}
          </FormRow>
          <EmaWarning receivingType={receivingType} />
          <NetWeightAndDimsFormRow getField={getField} />
          <FormRow>
            <Col md={12}>
              <Field
                name="minor_note"
                label="Minor Notes"
                component={TextArea}
                rows={5}
              />
            </Col>
          </FormRow>
          {getField(INTERNAL_NOTE) &&
            getField(INTERNAL_NOTE).trim() !== "" && (
              <FormRow>
                <Col md={12}>
                  <Field
                    name="internal_note"
                    label="Internal Note"
                    component={TextArea}
                    rows={5}
                    disabled
                  />
                </Col>
              </FormRow>
            )}
          <FieldArray
            attachmentTypes={ATTACHMENT_TYPES}
            name={ATTACHMENTS}
            getField={this.props.getField}
            component={AttachmentListSection}
          />
          <MistakeShipmentSection
            formName={formName}
            receivingType={receivingType}
          />
          {![EMA, MISTAKE_SHIPMENT].includes(receivingType) && (
            <React.Fragment>
              {!virtualReceiving &&
                Object.keys(RECEIVING_CHECKLIST_QUESTIONS).map(
                  this.renderChecklistQuestion
                )}
            </React.Fragment>
          )}
        </AppForm.Body>
        <FormFooter
          state={this.state}
          allValues={allValues}
          close={close}
          errorMessages={errorMessages}
          getInitialFieldValue={getInitialFieldValue}
          getField={getField}
          handleSubmit={handleSubmit}
          receiveAnother={this.receiveAnother}
          onSubmit={this.props.onSubmit}
          removeItem={this.props.removeItem}
          receivingRecord={receivingRecord}
          reset={this.props.reset}
          save={this.props.save}
          setFieldValue={setFieldValue}
          setState={this.setState}
          submitFailed={submitFailed}
          submitting={submitting}
          propValues={this.props}
          receivingType={receivingType}
        />
      </AppForm>
    );
  }
}

Form.propTypes = {
  getField: PropTypes.func.isRequired,
  getInitialFieldValue: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  searchParts: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  condition: PropTypes.string,
  quantity: PropTypes.number,
  receivingRecord: PropTypes.shape({}),
  errorMessages: PropTypes.arrayOf(PropTypes.str),
  removeItem: PropTypes.func.isRequired,
  searchBuyers: PropTypes.func.isRequired,
  submitFailed: PropTypes.bool,
  lockFields: PropTypes.bool,
  virtualReceiving: PropTypes.bool.isRequired
};
const selector = formValueSelector(formName);

export default connect(
  state => ({
    currentUser: state.session.get(USER).toJS(),
    allValues: getFormValues(formName)(state),
    condition: selector(state, CONDITION),
    getField: field => selector(state, field),
    getInitialFieldValue: field =>
      _.get(getFormInitialValues(formName)(state), field),
    quantity: selector(state, QUANTITY),
    receivingType: selector(state, RECEIVING_TYPE)
  }),
  dispatch => ({
    onSubmit: data => dispatch(create(data)),
    save: data => dispatch(save(data)),
    searchParts: filter => dispatch(partsActions.searchParts(filter)),
    searchBuyers: filter => dispatch(poActions.searchBuyers(filter)),
    setFieldValue: field => val => dispatch(change(formName, field, val))
  })
)(
  form({
    form: formName,
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Dashboard/Create/Form.jsx